import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface UserFeedbackState {
  isFeedbackConfirmSnackbarOpen: boolean;
  isTutorialEnabled: boolean;
}

export const initialUserFeedbackState: UserFeedbackState = {
  isFeedbackConfirmSnackbarOpen: false,
  isTutorialEnabled: true,
};

const userFeedbackFormSlice = createSlice({
  name: 'STRUCTURE_FORM',
  initialState: initialUserFeedbackState,
  reducers: {
    openFeedbackConfirmSnackbar: (state) => {
      return { ...state, isFeedbackConfirmSnackbarOpen: true };
    },
    closeFeedbackConfirmSnackbar: (state) => {
      return { ...state, isFeedbackConfirmSnackbarOpen: false };
    },
    setTutorialEnabled: (state, action: PayloadAction<boolean>) => {
      return { ...state, isTutorialEnabled: action.payload };
    },
  },
});

export const { openFeedbackConfirmSnackbar, closeFeedbackConfirmSnackbar, setTutorialEnabled } =
  userFeedbackFormSlice.actions;

export default userFeedbackFormSlice.reducer;
